import { ChainId } from '@/lib/chain'
import { TEnvConfig } from './env.interfact'
import { PROD_CONFIG } from './prod'

export const DEV_CONFIG: TEnvConfig = {
  ...PROD_CONFIG,
  amplitudeApiKey: '5fc3dae2d16504b413bd010d4978e8ae',
  supportedChains: [ChainId.ETHEREUM, ChainId.OPTIMISM, ChainId.BSC],
  defaultChainId: ChainId.OPTIMISM,
  kulapPlusApiBaseUrl: 'https://dev-plus-api.kulap.io/api/v1',
  kulapPlusUtilityFileUrl:
    'https://kulap-plus-utility-file-dev.s3.ap-southeast-1.amazonaws.com',
  kulapPlusTokenListFilePath: {
    [ChainId.ETHEREUM]: '/token-lists/ethereum.json',
    [ChainId.OPTIMISM]: '/token-lists/optimism.json',
    [ChainId.BSC]: '/token-lists/bsc.json'
  },
  kulapSwapFrontendUrl: 'http://alpha.kulap.io',
  kulapPlusFrontendUrl: 'https://dev-app.kulap.io',
  googleRecaptcha: '6Ld_pMUZAAAAAM5Pajn7kxKwQRbJGoqIRb3axu7Y',
  facebookAppId: '2228084830653503',
  initFromFiatCurrencyAmount: '17',
  checkUserEligibilityTrade: true,
  depositSwapContractAddresses: {
    [ChainId.ETHEREUM]: '0x8C298e78955Be0dc5bF35f51aC6E6D4689334597',
    [ChainId.BSC]: '0xf189Ba3B5f50D8600663c7239C4615F5e632233e',
    [ChainId.OPTIMISM]: '0xE3Af652366C50b1b449BFdf12c1090f26E434E8f'
  },
  // ? ThaiD type production
  // thaiD: {
  //   apiEndpoint: 'https://imauth.bora.dopa.go.th/api/v2',
  //   clientId: 'VGFFMzN2QXFTd2o4WUZUN3B4RlFjSU9ud3V2bUtvY0k',
  //   redirectUri:
  //     'https://dev-plus-api.kulap.io/api/v1/kyc-provider/thaid/callback'
  // }
  // ? ThaiD type [sandbox]
  thaiD: {
    apiEndpoint: 'https://imauthsbx.bora.dopa.go.th/api/v2',
    clientId: 'bXpYVEJsNmV4NUNLdTkxNVRDaXd1MTJJM3VlNFlVVGg',
    redirectUri:
      'https://dev-plus-api.kulap.io/api/v1/kyc-provider/thaid/callback'
  }
}
